import { OPEN_PRODUCT_MODAL } from "./types";

export default product => {
    return { type: OPEN_PRODUCT_MODAL, payload: product };
};
